import { render, staticRenderFns } from "./NewsField.vue?vue&type=template&id=1a1ec11b&scoped=true&"
import script from "./NewsField.vue?vue&type=script&lang=js&"
export * from "./NewsField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1ec11b",
  null
  
)

export default component.exports